import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { Tutorial } from '../../models/tutorial';
import { EditMenuComponent } from '../edit-menu/edit-menu.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
  imports: [NgClass, EditMenuComponent, DatePipe, MatProgressSpinner],
  standalone: true
})
export class TutorialComponent {
  @Input() tutorial: Tutorial | null = null;
  @Input() beingDownloaded = false;
  @Input() latest = false;
  @Output() clicked = new EventEmitter();
}
